<template>
    <div class="accountSecurity">
      <div class="header">
        <div class="title">
            {{t('account_security.title')}}
        </div>
        <div class="title_b">

        </div>
      </div>
      <div class="content">
        <div class="content_wrap">
            <div class="title1">
                <p>{{t('account_security.title1')}}</p>
                <p>{{t('account_security.title2')}}</p>
            </div>
            <div class="content1 flc">
              <div class="item fl">
                <div class="img">
                  <div class="img1"></div>
                </div>
                <div class="r">
                  <div class="title">{{t('account_security.content1.desc1.text_1')}}</div>
                  <div class="desc1">{{t('account_security.content1.desc1.text_2')}}
                    <br/>{{t('account_security.content1.desc1.text_3')}}</div>
                </div>
              </div>
              <div class="item fl">
                <div class="img">
                  <div class="img2"></div>
                </div>
                <div class="r">
                  <div class="title">{{t('account_security.content1.desc2.text_1')}}</div>
                  <div class="desc1">{{t('account_security.content1.desc2.text_2')}}
                    <br/>{{t('account_security.content1.desc2.text_3')}}</div>
                </div>
              </div>
              <div class="item fl">
                <div class="img">
                  <div class="img3"></div>
                </div>
                <div class="r">
                  <div class="title">{{t('account_security.content1.desc3.text_1')}}</div>
                  <div class="desc1">{{t('account_security.content1.desc3.text_2')}}<br/>{{t('account_security.content1.desc3.text_3')}}</div>
                </div>
              </div>
              <div class="item fl">
                <div class="img">
                  <div class="img4"></div>
                </div>
                <div class="r">
                  <div class="title">{{t('account_security.content1.desc4.text_1')}}</div>
                  <div class="desc1">{{t('account_security.content1.desc4.text_2')}}<br/>{{t('account_security.content1.desc4.text_3')}}</div>
                </div>
              </div>
              <div class="item fl">
                <div class="img">
                  <div class="img5"></div>
                </div>
                <div class="r">
                  <div class="title">{{t('account_security.content1.desc5.text_1')}}</div>
                  <div class="desc1">{{t('account_security.content1.desc5.text_2')}}<br/>{{t('account_security.content1.desc5.text_3')}}</div>
                </div>
              </div>
            </div>
            <div class="title2">
                {{t('account_security.title3')}}
            </div>
            <div class="content2">
              <div class="len fsp">
                <div class="left">
                  <p class="year">2017</p>
                  <p class="name">{{t('account_security.content3.desc1.text_1')}}</p>
                  <p class="des">{{t('account_security.content3.desc1.text_2')}}</p>
                </div>
                <div class="right">
                  <p class="year">2018</p>
                  <p class="name">{{t('account_security.content3.desc2.text_1')}}</p>
                  <p class="des">{{t('account_security.content3.desc2.text_2')}}</p>
                </div>
              </div>
              <div class="len fsp">
                <div class="left">
                  <p class="year">2017</p>
                  <p class="name">{{t('account_security.content3.desc1.text_1')}}</p>
                  <p class="des">{{t('account_security.content3.desc1.text_2')}}</p>
                </div>
                <div class="right">
                  <p class="year">2018</p>
                  <p class="name">{{t('account_security.content3.desc2.text_1')}}</p>
                  <p class="des">{{t('account_security.content3.desc2.text_2')}}</p>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="footer">{{t('account_security.phone')}}</div>
    </div>
</template>

<script>
import { onMounted } from "vue"
import { useI18n } from "vue-i18n"

export default {
  name: 'AccountSecurity',
  setup(){
    const { t } = useI18n()

    onMounted (() => {
      document.title = t('account_security.title')
    })

    return{
      t
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "./style.styl"
</style>